import { useHistory } from 'react-router';
import { useState } from 'react';

import {
  ALLOWED_PROJECTS_VALUES,
  CONCURRENCY_KEY,
  INTERVAL_KEY,
  PLAN_INTERVAL,
  PRODUCT_API_TESTING,
  PRODUCT_MOBILE_QUALITY,
  PROJECTS_KEY,
  ROUTE_PARENT_SECTION,
  ROUTE_SECTION_CHECKOUT,
} from '../constants';
import { trackEvent, EVENTS, MODE_USAGE } from '../tracking';

export interface SidePlanConfig {
  [INTERVAL_KEY]: string
  product: string
}

export const usePlanConfigManager = (
  updateProductConfig: (arg0: SidePlanConfig) => void,
  persistPurchaseData: () => void,
  initialLocalSidePlansConfig?: Record<string, SidePlanConfig>,
) => {
  const [localSidePlansConfig, setLocalSidePlansConfig] = useState(initialLocalSidePlansConfig ?? {
    [PRODUCT_API_TESTING]: {
      [INTERVAL_KEY]: PLAN_INTERVAL.YEAR,
      product: PRODUCT_API_TESTING,
      [PROJECTS_KEY]: ALLOWED_PROJECTS_VALUES[0],
    },
    [PRODUCT_MOBILE_QUALITY]: {
      [CONCURRENCY_KEY]: 1,
      [INTERVAL_KEY]: PLAN_INTERVAL.YEAR,
      product: PRODUCT_MOBILE_QUALITY,
    },
  });

  const history = useHistory();

  const proceedWithSidePlan = (product: string): void => {
    trackEvent(EVENTS.PLANS_CONTINUE, {
      ...MODE_USAGE,
      [INTERVAL_KEY]: localSidePlansConfig[product].interval,
      [product]: localSidePlansConfig[product][PROJECTS_KEY] || 1,
    });
    updateProductConfig(localSidePlansConfig[product]);
    persistPurchaseData();
    history.push(`/${ROUTE_PARENT_SECTION}/${ROUTE_SECTION_CHECKOUT}`);
  };

  const changeInterval = (isMonthly: boolean) => {
    const desiredInterval = isMonthly ? PLAN_INTERVAL.MONTH : PLAN_INTERVAL.YEAR;
    setLocalSidePlansConfig({
      ...localSidePlansConfig,
      [PRODUCT_API_TESTING]: {
        ...localSidePlansConfig[PRODUCT_API_TESTING],
        [INTERVAL_KEY]: desiredInterval,
      },
      [PRODUCT_MOBILE_QUALITY]: {
        ...localSidePlansConfig[PRODUCT_MOBILE_QUALITY],
        [INTERVAL_KEY]: desiredInterval,
      },
    });
  };

  return {
    localSidePlansConfig,
    setLocalSidePlansConfig,
    proceedWithSidePlan,
    changeInterval,
  };
};
